<card
  [title]="learndashTopic.post_title || ''"
  [showTitle]="[learndashTopic.post_title]"
  [isGrid]="true"
  [showDetailButton]="true"
  [detailUrl]="
    '/courses/' +
    [courseId] +
    '/lesson/' +
    [lessonId] +
    '/topic/' +
    [learndashTopic.id]
  "
  [detailButtonText]="'View Topic'"
>
</card>
